import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { NavigationEnd, Router } from "@angular/router";
import { SupportService } from "src/app/services/support-service";
import { SCHEDMED_ADMIN_ROUTE_SEGMENT } from "src/app/admin-route-segment";

@Component({
  selector: "app-super-admin-sidenav",
  templateUrl: "./super-admin-sidenav.component.html",
})
export class SuperAdminSidenavComponent implements OnInit {
  selectedlang: any = {};
  tcCode: any = "";
  adminsidemenu = false;
  fromReport = true;
  navigateURL = "";
  currentURL: any = "";
  dashboardLink = "";
  billingLogLink = "";
  billingErrorsLink = "";
  manageImagingCenterLink = "";
  schedmedReviewLink = "";
  reportMenuLink = "";

  constructor(
    private router: Router,
    private appservice: AppService,
    private supportService: SupportService
  ) {}
  ngOnInit() {
    this.supportService.adminsidemenu.subscribe((res) => {
      this.adminsidemenu = res;
    });

    if (sessionStorage.getItem("usertype") === "1") {
      const stored = localStorage.getItem("testCode");
      this.tcCode = stored && stored.trim() ? stored : SCHEDMED_ADMIN_ROUTE_SEGMENT;
    } else if (localStorage.getItem("testCode") !== null) {
      this.tcCode = localStorage.getItem("testCode");
    }

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });

    this.setAdminLinks();
    this.currentURL = this.getCurrentAdminPage();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentURL = this.getCurrentAdminPage();
      }
    });
  }

  setAdminLinks() {
    this.dashboardLink = this.adminLink("dashboard");
    this.billingLogLink = this.adminLink("billing-log");
    this.billingErrorsLink = this.adminLink("billing-errors");
    this.manageImagingCenterLink = this.adminLink("manage-imaging-center");
    this.schedmedReviewLink = this.adminLink("schedmed-review");
    this.reportMenuLink = this.adminLink("report-menu");
  }

  private adminLink(page: string): string {
    const stored = (localStorage.getItem("testCode") || "").trim();
    if (sessionStorage.getItem("usertype") === "1") {
      if (stored && stored !== SCHEDMED_ADMIN_ROUTE_SEGMENT) {
        return "/" + stored + "/" + SCHEDMED_ADMIN_ROUTE_SEGMENT + "/" + page;
      }
      return "/" + SCHEDMED_ADMIN_ROUTE_SEGMENT + "/" + page;
    }
    if (stored) {
      return "/" + stored + "/" + page;
    }
    return "/" + SCHEDMED_ADMIN_ROUTE_SEGMENT + "/" + page;
  }

  getCurrentAdminPage(): string {
    const parts = (this.router.url || "")
      .split("?")[0]
      .split("/")
      .filter((part) => part.length > 0);
    const adminIndex = parts.indexOf(SCHEDMED_ADMIN_ROUTE_SEGMENT);
    if (adminIndex >= 0 && parts.length > adminIndex + 1) {
      return parts[adminIndex + 1];
    }
    if (parts.length >= 2) {
      return parts[parts.length - 1];
    }
    return parts[0] || "dashboard";
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    this.currentURL = type;
  }
}
